export const PROBLEM_PROOF_BRIDGE = {
  label: "FROM SCENARIO TO LIVE PROOF",
  headline: "This isn't hypothetical.",
  body: "A partner agency already deployed this stack for a live client. The mechanics above are running in production. Not a slide deck.",
};
